<template>
  <div>
    <div class="bg"></div>
    <div id="home">
      <img style="width: 180px;margin-bottom: 50px;" src="../assets/imgs/money.png"/>
      <h1>간편하게 가입/로그인하고<br/>예상 퇴직금을 계산해 보세요.</h1>


      <div class="btn" @click="go_kakao_login()" style="margin-top: 200px;">
        <img src="../assets/imgs/kakao_logo.png"/>
        카카오 로그인
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  export default {
    name: 'Home',
    components: {

    },
    data() {
      return {

      }
    },
    methods:{
      go_kakao_login(){
        window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.VUE_APP_KAKAO_CLIENT_ID}&redirect_uri=` + process.env.VUE_APP_KAKAO_REDIRECT_URI + `&response_type=code&state=2`
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{position: absolute;height: 100vh;display: flex;flex-direction: column;align-items: center;width: 100%;justify-content: center;text-align: center;}
  h1{color:#333333;font-size: 24px;line-height: 34px;}
  .btn{font-size:18px;display: flex;justify-content: center;background:#fee500;margin-top:40px;align-items: center;padding:0 30px;height: 52px;border-radius: 8px;color:#000000;}
  .btn img{width: 22px;margin-right: 10px;}
  .bg{position: absolute;top:0;left:0;width: 100%;height:45vh;background-image: linear-gradient(to bottom,#DCE4FF,#ffffff);}
</style>
